import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"

const StyledCenterText = styled.div`
  text-align: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
  }
`

export const StyledHeaderH1 = styled(Typography).attrs({ variant: "h1" })<{
  $margin?: number
  $align?: string
  $break?: string
}>`
  text-align: ${(p) => (p.$margin ? `center` : "center")};
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "0")};
  word-break: ${(p) => p.$break && p.$break};
  font-family: "OENaPro";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.05em;
  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: ${(p) => (p.$align ? p.$align : "right")};
  }
`
const StyledHeaderSubtitle = styled(Typography).attrs({ variant: "h2" })`
  font-size: 20px;
  margin-top: 20px;
  font-weight: 300;
`
const StyledBody = styled(Typography).attrs({ variant: "body1" })<{
  $margin: boolean
  $page: string
}>`
  margin-top: 20px;
  font-family: "OENaPro";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 27px;
  color: ${(p) => p.theme.colors.black};
  width: ${(p) => (p.$page === "color" ? "500px" : "985px")};
  margin: auto;
  ${(p) => p.$margin && "margin-top: 20px"};
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
    width: 100%;
  }
`
const StyledLine = styled.div`
  height: 0.5px;
  background-color: ${(p) => p.theme.colors.darkGrey};
  margin-top: 40px;
`
const StyledFooterText = styled(Typography).attrs({ variant: "body2" })`
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
`

type CenterTextProps = {
  title: string
  subtitle?: string
  headerText: string[]
  footerText?: string
  withBorder?: boolean
  margin?: boolean
  page?: string
}
const CenterText = ({
  title,
  subtitle,
  headerText,
  footerText,
  withBorder,
  margin,
  page,
}: CenterTextProps) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledCenterText>
      {title && <StyledHeaderH1>{title}</StyledHeaderH1>}
      {subtitle && <StyledHeaderSubtitle>{subtitle}</StyledHeaderSubtitle>}
      {headerText.map((text) => (
        <StyledBody key={text} $margin={margin} $page={page}>
          {text}
        </StyledBody>
      ))}
      {footerText ? <StyledFooterText>{footerText}</StyledFooterText> : null}
      {isDesktop && withBorder && <StyledLine />}
    </StyledCenterText>
  )
}

export default CenterText
